import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';
import { verifyDocument } from '@app/_models/verifyDocument';
import { LogService } from '@app/_shared/log.service';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxSpinnerService } from "ngx-spinner";
import { ChangeDetectorRef } from '@angular/core';
import { UpdatePaymentReq } from '@app/_models/updatePaymentReq';
import { environment } from '@environments/environment';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-verify-document',
  templateUrl: './verify-document.component.html',
  styleUrls: ['./verify-document.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class VerifyDocumentComponent implements OnInit {
  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, i) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    var r=this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    // var v = moment(this.form.value.StudentDocVerificationRequest[0].yearAndMonth.month() + 1, 'MM').format('MMMM');
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);


    myForm.patchValue({
      yearAndMonth: this.date.value,
      yearAndMonthSelect: this.date.value,
     monthOfPassing:moment(this.date.value.month()+1, 'MM').format('MMMM'),
     yearofpassid:r.id,
    });

  }

  firstName: string = localStorage.getItem('firstname');
  lastName: string = localStorage.getItem('lastname');
  userId = localStorage.getItem('user_id');
  // embassyname: string = "NA";
  embassyaddress: string = ('NA');
  showErr = false;
  streamDropDown = [];
  collegeDropDown = [];
  YearOfPassDropDown = [];
  documentDropDown = [];
  branchDropDown = [];
  EmbassyDropDown = [];
  semesterDropDown = [];
  finalArray = [];
  filePath;
  submitted = false;
  RequestTypeDropDown = [];
  strMessage: string;
  fileSizeErr = false;
  EmbassyshowErr = false;
  amount;
  IsmodelShow
  saveIds: any = 0;
  getStreamId: number;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  EMAIL_REGEXP = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?\.)+[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?/;
  returnUrl;
  form: FormGroup;
  embassyidDisabled = true;
  ifZeroAmount = false;
  noYrPriceMast;
  altEmailLengthCheck = false;
  altEmailValidation = false;
  errorMessage: string = '';
  verifyDocument = new verifyDocument();

   updatePaymentReq  = new UpdatePaymentReq();
 
 // form = new form();

  // finalArray = [];
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBoxAlert', { read: TemplateRef }) showModalBoxAlertTemplate: TemplateRef<any>;

  constructor(private modalService: NgbModal, config: NgbModalConfig,
    private fb: FormBuilder,
    private router: Router,
    private verifyDocService: VerifyDocumentService,
    private eventService: LogService,
    private SpinnerService: NgxSpinnerService,
    private cdr: ChangeDetectorRef

  ) {
    this.form = this.fb.group({
     // embassyname: ['']
    });
    
  }
  
 
  dateFilter = (d: any): boolean => {     
    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
    //return aq;
  }


  @ViewChild('closebuttonRemark') closebuttonRemark;

  email = localStorage.getItem('userName');
  name = localStorage.getItem('firstname') + '' + localStorage.getItem('lastname');
  phoneNo = localStorage.getItem('phoneNo');

  options = {
    // Enter the Key ID generated from the Dashboard - set per-environment in
    // environment.ts (test) / environment.prod.ts (live), not hardcoded here.
    "key": environment.razorpayKey,
    "amount": 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "University",
    "description": "Verification Transaction",
    // "image": "assets/images/logo.png",

    // "order_id": "", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    //  "callback_url": "http://192.168.0.104:4200/PaymentSuccessfulPage?ids="+ this.saveIds,//"http://mu.secur.co.in:8080/University/login",
    //  "redirect":true,
    // "callback_url": 'https://www.google.com',
    // "handler": function (response) {
    //   this.IsmodelShow=true;
    //   let paymentId = response.razorpay_payment_id;
    //  //  alert(response.razorpay_payment_id);

    //   // alert(response.razorpay_order_id);
    //   // alert(response.razorpay_signature);
    //   // this.callDispute(1)
    // },
    "handler": (response) => {
      // console.log(response);//this returns the expected value
      // alert('payment successfully done, verification request has been created. Please click on home tab');


      this.updatePaymentReq.paymentid=response.razorpay_payment_id;

      // this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      //   this.form.value.StudentDocVerificationRequest[i].paymentId = response.razorpay_payment_id;
      //   this.form.value.StudentDocVerificationRequest[i].createby = localStorage.getItem('user_id');
      // });

       console.log("after payment---", this.updatePaymentReq)

       this.updatePaymentReq.paymentid= response.razorpay_payment_id;
        console.log("after payment",this.updatePaymentReq);


              this.verifyDocService.updateStudentVerificationPaymentFlag(this.updatePaymentReq)
                      .pipe(first())
                      .subscribe(
                        data => {
                          console.log("response---after save ver req", data)
                          if (data.respMessage == "Success") {
                          
                        this.modalService.open(this.showModalBoxTemplate);
                        this.closebuttonRemark.nativeElement.click();

                          }
                        },
                        error => {
                          console.log(error)
                        }
                      )

    },
    "modal": {
      "ondismiss": function () {
        //this.IsmodelShow=true;
        //alert('close');  
        // this.modalService.open(this.showModalBoxTemplate);
      }
    },
    "prefill": {
      "name": "Rupali Jadhav",
      "email": "manisha.lohbande@scubetechserv.com",
      "contact": "9168781259"
    },
    "notes": {
      "address": "Razorpay Corporate Office"
    },
    "theme": {
      "color": "#3399cc"
    }
  };

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }
  ngOnInit(): void {
    this.IsmodelShow = false;
    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
          console.log("streamdropdown = ", this.streamDropDown)
        },
        error => {
          console.log(error)
        }
      )

      
      this.verifyDocService.getEmbassy()
      .pipe(first())
      .subscribe(
        data => {
           console.log("getEmbassy response---", data.respData)
          this.EmbassyDropDown = data.respData;
    //     console.log("getEmbassy response---", this.EmbassyDropDown)
     // alert("Check Embassy ----"+data.id);
     //  alert('payment_id: ' + payment_id);
        },
        error => {
          console.log(error)
        }
      )


     


    this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
         
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getDocuments()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("Document response---", data.respData)
          this.documentDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )




    this.form = this.fb.group({
      StudentDocVerificationRequest: this.fb.array([
        this.initTimes()
      ])
    });

    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest"));

    const currentForm = myForm.value[0].embassyid;

    // this.fa.valueChanges.subscribe(value => {
    //   console.log('name 33has changed:', value[0].embassyid)
    // });

    this.fa.valueChanges.subscribe(value => {
      console.log('name has changed:', value)
    });


    // const val = this.fb.group({
    //   streamid: ['', Validators.required],
    //   docname: ['', Validators.required],
    //   requesttype: ['', Validators.required],
    //   enrollno: ['', Validators.required],
    //   yearofpassid: ['', Validators.required],
    //   collegenameid: ['', Validators.required],
    //   uniid: '1',
    //   userid: localStorage.getItem('user_id'),
    //   firstname: ['', Validators.required],
    //   lastname: ['', Validators.required],
    //   uploaddocpath: '',
    //   filepath: ['', Validators.required],
    //   // reqtype: ['', Validators.required],
    // });

    // const form = this.form.get('StudentDocVerificationRequest') as FormArray
    // form.push(val);

  }

  // verificationPurposeChange(val) { 
  //   console.log("inpVal = ", val);

  //   if (val === '1') {
  //     console.log("inpVal44 = ", val);
  //     this.form.controls.gstExemption.enable();
   
  //   } 

  // }

 
 

  
  
  initTimes() {
    return this.fb.group({
      streamid: this.fb.control('', Validators.required),
      semId: this.fb.control('', Validators.required),
      embassyid: this.fb.control('', Validators.required),
      branchId: this.fb.control('', Validators.required),
      docname: this.fb.control('', Validators.required),
      requesttype: this.fb.control('', Validators.required),
      enrollno: this.fb.control('', Validators.required),
      yearofpassid: this.fb.control('', Validators.required),
      collegenameid: this.fb.control('', Validators.required),
      uniid: "1",
      userid: localStorage.getItem('user_id'),
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      uploaddocpath: this.fb.control('', Validators.required),
      filepath: this.fb.control('', Validators.required),
      altEmail: this.fb.control(''),
      trackingId: this.generateUniqueId(),
      yearAndMonth: this.fb.control(''),
      yearAndMonthSelect: this.fb.control(''),
      monthOfPassing: this.fb.control(''),
     // embassynames: this.fb.control('NA', Validators.required),
     // embassyaddress: this.fb.control('', Validators.required)
     embassyname: this.fb.control('NA',  this.EmbassyshowErr ? null : Validators.required),
     embassyaddress: this.fb.control('NA', this.EmbassyshowErr ? null : Validators.required),
   // embassyname: this.fb.control( '',this.embassyidDisabled ? null : Validators.required),
   // embassyaddress: this.fb.control('',this.embassyidDisabled ? null : Validators.required)
 //  embassyname: this.fb.control('', this.customValidation(this.embassyidDisabled, this.EmbassyshowErr)),
//  embassyaddress: this.fb.control('', this.customValidation(this.embassyidDisabled, this.EmbassyshowErr)),

    });
  }

  get fa() 
  { 
    return this.form.get('StudentDocVerificationRequest') as FormArray; 
  }

  generateUniqueId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  patternCheck(email) {
    console.log("check pattern", email);
  }

  inputChanged(event: any, index){
    console.log('inputChanged function--->',event.target.value);
    var inputString = event.target.value;

    // var inputString = document.getElementById('emailinput').value;
    var splitInput = inputString.split(',');

    if(splitInput.length > 5){
      this.altEmailLengthCheck = true;
    }else{
      this.altEmailLengthCheck = false;
    }

    var pattern = this.EMAIL_REGEXP;

    var match = true;
    var count = 0;
    for(var i=0;i<splitInput.length;i++) {
      if(!String(splitInput[i]).match(pattern)){
        match = false;
        count = count +1;
        console.log('match = false')
        this.altEmailValidation = true;
      }
    }
    if(count == 0){
      this.altEmailValidation = false;
    }
    console.log('------BOOLEAN------->',this.altEmailLengthCheck, this.altEmailValidation)
  }

  // customValidation(embassyidDisabled: boolean, EmbassyshowErr: boolean) {
  //   return (control) => {
  //     if (embassyidDisabled  && EmbassyshowErr) {
  //       console.log('------embassyidDisabled------->',embassyidDisabled, EmbassyshowErr)
  //       return null; // No validation if embassyidDisabled is true
  //     } else if (EmbassyshowErr) {
  //       return Validators.required(control); // Apply required validation
  //     } else {
  //       return null; // No validation if EmbassyshowErr is false
  //     }
  //   };
  // }

  onSubmit() {
   
    console.log('valid: ', this.form.valid);
    // console.log('', this.form.value.StudentDocVerificationRequest)

    this.submitted = true;
    if (this.form.valid == false) {
      console.log("here")
      this.showErr = true;
      return;
    }
    this.finalArray.push(this.form.value);
    console.log(this.finalArray)
    debugger;

    this.verifyDocService.getAmount(this.form.value.StudentDocVerificationRequest)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          if (data.respMessage == "Success") {
            if (data.respData.total_with_gst[0] == 99999) {
              this.noYrPriceMast = data.respData.YearNotDefined.join(",");
              this.ifZeroAmount = true;
              return;
            }
            else {
              this.ifZeroAmount = false;//
              this.amount = data.respData.total_with_gst[0];//data.respData.total_with_gst;
            // this.amount = data.respData.total_with_gst;
            console.log("amount2", this.amount * 100);
            this.strMessage = "payment successfully done, verification request has been created";
            this.options.prefill.contact = this.phoneNo;
            this.email = this.email.replace(/"|'/g, '');;
            this.options.prefill.name = this.name;
            this.options.prefill.email = this.email;
            this.options.amount = this.amount * 100;
            console.log("razorpayamount", this.options.amount);
            this.modalService.open(this.showModalBoxAlertTemplate);
            // let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
            // rzp1.open();
            }
          }
        },
        error => {
          console.log(error)
        }
      )


    // this.verifyDocService.saveStudentVerificationDoc(this.form.value.StudentDocVerificationRequest)
    //   .pipe(first())
    //   .subscribe(
    //     data => {
    //       console.log("response---", data)
    //       if (data.respMessage == "Success") {
    //         console.log("amount---", data.respData.total_with_gst)
    //         this.amount = data.respData.total_with_gst;
    //         this.saveIds= data.respData.saveDocID;
    //         // alert("Verification Doc has been saved. Total Amount With GST: " + data.respData.total_with_gst);
    //         // this.eventService.emit<string>("0")

    //         console.log("amount2", this.amount * 100)

    //         this.strMessage = "payment successfully done, verification request has been created";
    //         this.options.prefill.contact = this.phoneNo;
    //         this.email = this.email.replace(/"|'/g, '');;
    //         this.options.prefill.name = this.name;
    //         this.options.prefill.email = this.email;
    //         this.options.amount = 1 * 100;
    //         let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
    //         rzp1.open();

    //         // this.strMessage = "Verification Doc has been saved. Total Amount With GST: " + data.respData.total_with_gst;
    //         // this.strMessage = "payment successfully done, verification request has been created";
    //         // this.modalService.open(this.showModalBoxTemplate);
    //       }
    //     },
    //     error => {
    //       console.log(error)
    //     }
    //   )



  }
  closeAlert() {

  console.log("closeAlert")

      this.verifyDocService.saveStudentVerificationDoc(this.form.value.StudentDocVerificationRequest)
        .pipe(first())
        .subscribe(
          data => {
            console.log("response---after save ver req", data)
            if (data.respMessage == "Success") {
              console.log("amount---closeAlert", data.respData.total_with_gst)
              this.amount = data.respData.total_with_gst;
              this.saveIds = data.respData.saveDocID;
              this.updatePaymentReq.verreqid=data.respData.saveDocID;
              this.updatePaymentReq.verreqidarr=data.respData.saveDocID;
              this.updatePaymentReq.userid=localStorage.getItem('user_id');


              // this.updatePaymentReq.paymentid="9000";
              // console.log("after payment",this.updatePaymentReq);


              // this.verifyDocService.updateStudentVerificationPaymentFlag(this.updatePaymentReq)
              //         .pipe(first())
              //         .subscribe(
              //           data => {
              //             console.log("response---after save ver req", data)
              //             if (data.respMessage == "Success") {
                          
              //             }
              //           },
              //           error => {
              //             console.log(error)
              //           }
              //         )





             // this.modalService.open(this.showModalBoxTemplate);
             //  this.closebuttonRemark.nativeElement.click();
            }
          },
          error => {
            console.log(error)
          }
        )

console.log("after save",this.updatePaymentReq);


   this.modalService.dismissAll(this.showModalBoxAlertTemplate);
    // this.closebuttonAlert.nativeElement.click();
   let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
    rzp1.open();






  }

  addGroup() {

    // form.push(val);
    this.fa.push(this.initTimes());

  }

  removeGroup(index) {
    // const form = this.form.get('StudentDocVerificationRequest') as FormArray
    // const temp = form.at(index);

    // console.log(form);
    // console.log(temp);
    // form.removeAt(index);
    this.fa.removeAt(index);
  }

  trackByFn(index: any, item: any) {
    return item.trackingId;
  }

  refresh(): void {
    location.reload();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.eventService.emit<string>("0")
    // this.returnUrl = "employer";
    // this.router.navigate([this.returnUrl]);
  }


  catchEvent(files: FileList, i) {
    this.SpinnerService.show();

    console.log(files)
    console.log(i)
    if (files[0].size <= 5242880) {
      this.fileSizeErr = false;

      var formData = new FormData();
      formData.append("file", files.item(0));
      this.verifyDocService.uploadVerificationDocumentFile(formData)
        .pipe(first())
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            this.SpinnerService.hide();
            console.log(this.form.controls.StudentDocVerificationRequest.value[0]['uploaddocpath'])

            this.updateData(i, data.respData);

          },
        
            error => {
              // Hide the loading spinner if an error occurs during file upload
              this.SpinnerService.hide();
            //  console.log("Hello", error?.error?.respMessage || "SomeThing Went Wrong, Please Check Internet Connectivity, Please Try Again After Some Time.");
              // Set the error message to be shown in the template
              this.errorMessage = error.message;
              
            }


          
        )
    } else {
      const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);

      myForm.patchValue({
        filepath: ""
      });
      
      this.fileSizeErr = true;
      this.SpinnerService.hide();

    }
  }

  updateData(index: number, data: String) {
    console.log(index, data)
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(index);

    myForm.patchValue({
      // firstname: this.firstName,
      // lastname: this.lastName,
      filepath: data
    });
    console.log("Before=>", myForm);
    console.log("Before=>", myForm.value);
    console.log(myForm.value.firstname)
  }
  pay() {
    this.strMessage = "payment successfully done, verification request has been created";
    this.options.prefill.contact = this.phoneNo;
    this.email = this.email.replace(/"|'/g, '');;
    this.options.prefill.name = this.name;
    this.options.prefill.email = this.email;
    let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
    rzp1.open();
  }

  successCallback = (payment_id) => { // <- Here!
    // alert('payment_id: ' + payment_id);
    this.strMessage = "payment successfully done, verification request has been created";
    this.modalService.open(this.showModalBoxTemplate);
  };

  /*
getembassylist(i: any, index){
  let y = i.split(':')[1];

    let id = Number(y);
    //  alert(  Number(this.emb));
  this.verifyDocService.getEmbassybyId(id)
  .pipe(first())
  .subscribe(
    data => {
       console.log("college response---", data.respData)
      this.EmbassyDropDown[index] = data.respData;
    },
    error => {
      console.log(error)
    }
  )
}
*/
  getBranAndStream(i: any, index) {
    let y = i.split(':')[1];

    let id = Number(y);
    // alert(  Number(this.getStreamId));

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
           console.log(" check college response---", data.respData)
          this.branchDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("semester response---", data.respData)
          this.semesterDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }

  
  getembassylist(i: any, index){
    let y = i.split(':')[1];
  
      let id = Number(y);
      //  alert(  Number(this.emb));
    this.verifyDocService.getEmbassybyId(id)
    .pipe(first())
    .subscribe(
      data => {
        this.EmbassyDropDown[index] = data.respData;
        const val = data.respData[0].id
        console.log("college response---", val);
        if (val == 1 || val ==3) {
      
          this.embassyidDisabled = false;  
          this.EmbassyshowErr = true;

          this.cdr.detectChanges();
          console.log("Value of embassyidDisabled:", this.embassyidDisabled);
         //   this.form.controls.embassyname.disable();
               console.log("inpVal when disable11 = ", val);
              //  const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);
              //  myForm.patchValue({
              //   embassyname:"NA"
              //  });
              console.log("CHeck JJJJ",this.form.value);

            } else{

              this.embassyidDisabled = true;
              this.EmbassyshowErr = false;
              console.log("Esle fasle:", this.embassyidDisabled);
           //   this.fb.control('embassynames').clearValidators();
          //    this.showErr = false;
          //    this.form.controls.embassyname.disable();
            }
      },
      error => {
        console.log(error)
      }
    )
  }

}
